export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const ENDPOINTS = {
  // ── Auth ──────────────────────────────────────────────────────────────
  AUTH_LOGIN: `${API_URL}/auth/login`,
  AUTH_LOGIN_SELECT: `${API_URL}/auth/login/select`,
  AUTH_CHANGE_PASSWORD: `${API_URL}/auth/change-password`,
  AUTH_SWITCH_ROLE: `${API_URL}/auth/switch-role`,

  // ── Currículum ────────────────────────────────────────────────────────
  COURSES: `${API_URL}/courses`,
  COURSE_SUBJECTS: (courseId) => `${API_URL}/courses/${courseId}/subjects`,
  SUBJECT_UNITS: (subjectId) => `${API_URL}/subjects/${subjectId}/units`,
  COURSE_SECTIONS_BY_COURSE: (courseId, sectionId) => sectionId ? `${API_URL}/course-sections/by-course/${courseId}?section_id=${sectionId}` : `${API_URL}/course-sections/by-course/${courseId}`,
  UNIT_VALID_DATES: (unitId) => `${API_URL}/units/${unitId}/valid-dates`,

  // ── Objetivos de Aprendizaje (OA) ─────────────────────────────────────
  OAS_BY_UNIT: (unitId, sectionId) => sectionId ? `${API_URL}/oas/${unitId}?section_id=${sectionId}` : `${API_URL}/oas/${unitId}`,
  OA_PLANNED_CLASSES: (oaId) => `${API_URL}/oas/${oaId}/planned_classes`,

  // ── Planificación ─────────────────────────────────────────────────────
  PLANNING_SAVE: `${API_URL}/planning/save`,

  // ── Clases planificadas ───────────────────────────────────────────────
  PLANNED_CLASSES: `${API_URL}/planned-classes/`,
  PLANNED_CLASS: (id) => `${API_URL}/planned-classes/${id}`,
  PLANNED_CLASS_COMMENTS: (id) => `${API_URL}/planned-classes/${id}/comments`,
  PLANNED_CLASS_APPROVAL: (id) => `${API_URL}/planned-classes/${id}/approval`,
  PLANNED_CLASS_CHANGE_REQUEST: (id) => `${API_URL}/planned-classes/${id}/change-request`,
  // Matriz OA x Clase — módulo Planificación (docs/oa_modif.md). startDate/endDate son
  // opcionales: si se omiten, el backend usa el rango del semestre vigente de la sección.
  OA_CLASS_MATRIX: (sectionId, startDate, endDate) =>
    (startDate && endDate)
      ? `${API_URL}/planned-classes/oa-matrix/${sectionId}?start_date=${startDate}&end_date=${endDate}`
      : `${API_URL}/planned-classes/oa-matrix/${sectionId}`,
  OA_CLASS_MATRIX_SAVE: (sectionId) => `${API_URL}/planned-classes/oa-matrix/${sectionId}`,
  PLANNED_CLASS_FULL_DETAIL: (id) => `${API_URL}/planned-classes/${id}/full-detail`,
  PLANNED_CLASS_REPLICATE: (id) => `${API_URL}/planned-classes/${id}/replicate`,
  PLANNED_CLASS_SECTIONS_WITH_CLASSES: (sectionId, competencyId) =>
    `${API_URL}/planned-classes/sections-with-classes/${sectionId}/${competencyId}`,
  PLANNED_CLASS_BY_SECTION_AND_OA: (sectionId, competencyId) =>
    `${API_URL}/planned-classes/by-section-and-oa/${sectionId}/${competencyId}`,
  PLANNED_CLASS_REPLICATE_PLANNING: `${API_URL}/planned-classes/replicate-planning`,
  PLANNED_CLASS_REPLICATE_PLANNING_STATS: `${API_URL}/planned-classes/replicate-planning/stats`,
  PLANNED_CLASS_CLEAR_PLANNING: (sectionId) => `${API_URL}/planned-classes/clear-planning/${sectionId}`,

  // ── Ejecución de clases ───────────────────────────────────────────────
  CLASS_EXECUTION_PLANNED_CLASSES: (sectionId) =>
    `${API_URL}/class-execution/section/${sectionId}/planned-classes`,
  CLASS_EXECUTION_REASONS: `${API_URL}/class-execution/reasons/class-execution`,
  EVALUATION_REASONS: `${API_URL}/class-execution/reasons/evaluation`,
  CLASS_EXECUTION_BATCH_SAVE: `${API_URL}/class-execution/batch-save`,

  // ── Dashboard – Docente ───────────────────────────────────────────────
  DASHBOARD_SUMMARY: `${API_URL}/dashboard/summary`,
  DASHBOARD_PLANNING_STATS_BY_SECTION: `${API_URL}/dashboard/planning-stats-by-section`,
  DASHBOARD_TOP_UNPLANNED_SECTIONS: `${API_URL}/dashboard/top-unplanned-sections`,
  DASHBOARD_COURSE_PLANNING_PROGRESS: `${API_URL}/dashboard/course-planning-progress`,

  // ── Dashboard – UTP ───────────────────────────────────────────────────
  DASHBOARD_UTP_ALL_PLANNED_CLASSES: `${API_URL}/dashboard/utp/all-planned-classes`,
  DASHBOARD_UTP_PLANNING_SUMMARY: `${API_URL}/dashboard/utp/planning-summary`,
  DASHBOARD_UTP_COURSES_WITH_SUBJECTS: `${API_URL}/dashboard/utp/courses-with-subjects`,
  DASHBOARD_UTP_TEACHER_STATUS: `${API_URL}/dashboard/utp/teacher-status`,
  DASHBOARD_UTP_WEEKLY_STATS: `${API_URL}/dashboard/utp/weekly-stats`,
  DASHBOARD_UTP_TEACHER_MONITORING: `${API_URL}/dashboard/utp/teacher-monitoring`,
  DASHBOARD_UTP_TEACHER_SECTION_MONITORING: `${API_URL}/dashboard/utp/teacher-section-monitoring`,
  DASHBOARD_UTP_PLANNING_REPORT_EXPORT: `${API_URL}/dashboard/utp/planning-report/export`,
  DASHBOARD_UTP_STATUS_THRESHOLDS: `${API_URL}/dashboard/utp/status-thresholds`,
  DASHBOARD_UTP_WEEKLY_TREND: `${API_URL}/dashboard/utp/weekly-trend`,
  DASHBOARD_UTP_SEMESTER_EXECUTION_STATS: `${API_URL}/dashboard/utp/semester-execution-stats`,

  // ── Dotación Docente ──────────────────────────────────────────────────
  TEACHER_STAFFING_OVERVIEW: `${API_URL}/teacher-staffing/overview`,
  TEACHER_STAFFING_SECTION_PLANNED_CLASSES: (sectionId) => `${API_URL}/teacher-staffing/section/${sectionId}/planned-classes`,
  TEACHER_STAFFING_ACTIVE_TEACHERS: `${API_URL}/teacher-staffing/active-teachers`,
  TEACHER_STAFFING_CHANGES: `${API_URL}/teacher-staffing/changes`,
  TEACHER_STAFFING_REVERT: (changeId) => `${API_URL}/teacher-staffing/changes/${changeId}/revert`,
  TEACHER_STAFFING_HISTORY: `${API_URL}/teacher-staffing/history`,

  // ── Notificaciones ────────────────────────────────────────────────────
  NOTIFICATIONS: `${API_URL}/notifications`,
  NOTIFICATION_READ: (id) => `${API_URL}/notifications/${id}/read`,
  NOTIFICATIONS_READ_ALL: `${API_URL}/notifications/read-all`,
  NOTIFICATIONS_SSE: (token) => `${API_URL}/notifications/stream?token=${token}`,

  // ── Admin – Etapas de clase ───────────────────────────────────────────
  ADMIN_CLASS_STAGES: `${API_URL}/admin/class-stages`,
  ADMIN_CLASS_STAGES_OPERATIONS: `${API_URL}/admin/class-stages/operations`,

  // ── Admin – Plantilla de Planificación de Clases ──────────────────────
  ADMIN_PLANNING_TEMPLATE: `${API_URL}/admin/planning-template`,

  // ── Admin – Marcos de competencia (solo lectura, para asociar cursos) ─
  ADMIN_COMPETENCY_FRAMEWORKS: `${API_URL}/admin/competency-frameworks`,

  // ── Admin – Objetivos de Aprendizaje / Habilidades y Actitudes (solo lectura,
  //    navegación directa por Marco de Competencias, docs/gestion_academica.md fase 2) ─
  ADMIN_FRAMEWORK_UNITS_OBJECTIVES: (frameworkId) => `${API_URL}/admin/frameworks/${frameworkId}/units-objectives`,
  ADMIN_FRAMEWORK_SKILLS_ATTITUDES: (frameworkId) => `${API_URL}/admin/frameworks/${frameworkId}/skills-attitudes`,

  // ── Master – Marcos de Competencias (CRUD, catálogo transversal) ─────
  MASTER_COMPETENCY_FRAMEWORKS: `${API_URL}/master/competency-frameworks`,
  MASTER_COMPETENCY_FRAMEWORK: (id) => `${API_URL}/master/competency-frameworks/${id}`,
  MASTER_COMPETENCY_FRAMEWORK_RENAME: (id) => `${API_URL}/master/competency-frameworks/${id}/rename`,

  // ── Master – Objetivos de Aprendizaje / Habilidades y Actitudes (CRUD,
  //    navegación directa por Marco de Competencias, docs/gestion_academica.md fase 2) ─
  MASTER_FRAMEWORK_UNITS_OBJECTIVES: (frameworkId) => `${API_URL}/master/frameworks/${frameworkId}/units-objectives`,
  MASTER_FRAMEWORK_SKILLS_ATTITUDES: (frameworkId) => `${API_URL}/master/frameworks/${frameworkId}/skills-attitudes`,
  MASTER_FRAMEWORK_TRANSVERSAL_NODE_ENSURE: (frameworkId) => `${API_URL}/master/frameworks/${frameworkId}/transversal-node/ensure`,
  MASTER_COMPETENCY_DEFINITIONS: `${API_URL}/master/competency-definitions`,
  MASTER_COMPETENCY_DEFINITIONS_OPERATIONS: `${API_URL}/master/competency-definitions/operations`,
  MASTER_COMPETENCY_DEFINITION: (id) => `${API_URL}/master/competency-definitions/${id}`,
  MASTER_COMPETENCY_DEFINITION_DEPENDENCIES: (id) => `${API_URL}/master/competency-definitions/${id}/dependencies`,

  // ── Admin – Cursos ────────────────────────────────────────────────────
  ADMIN_COURSES: `${API_URL}/admin/courses`,
  ADMIN_COURSES_BY_SUBJECT: (subject) => `${API_URL}/admin/courses-by-subject/${subject}`,
  ADMIN_COURSE_UNITS_OBJECTIVES: (courseId) => `${API_URL}/admin/course-units-objectives/${courseId}`,
  ADMIN_COURSE_SECTIONS: (courseId) => `${API_URL}/admin/course-sections/${courseId}`,
  ADMIN_COURSE_SUBJECT_ASSOCIATIONS_OPERATIONS: `${API_URL}/admin/course-subject-associations/operations`,
  ADMIN_SKILLS_ATTITUDES_BY_COURSE: (courseId) => `${API_URL}/admin/skills-attitudes-by-course/${courseId}`,
  ADMIN_COURSE_TRANSVERSAL_ELEMENTS: (courseId) => `${API_URL}/admin/course-transversal-elements/${courseId}`,
  ADMIN_COURSE_OBJECTIVE_ELEMENTS: (courseId) => `${API_URL}/admin/course-objective-elements/${courseId}`,
  ADMIN_COURSE_UNITS: (courseId) => `${API_URL}/admin/course-units/${courseId}`,
  ADMIN_CREATE_UNIT0: `${API_URL}/admin/create-unit0`,
  ADMIN_DUPLICATE_OAS_FOR_UNIT0: `${API_URL}/admin/duplicate-oas-for-unit0`,
  ADMIN_DELETE_UNIT0: (courseId) => `${API_URL}/admin/delete-unit0/${courseId}`,

  // ── Admin – Organizaciones ────────────────────────────────────────────
  ADMIN_ORGANIZATIONS: `${API_URL}/admin/organizations`,
  ADMIN_ORGANIZATIONS_COURSE_SECTIONS: `${API_URL}/admin/organizations?organization_type=Secci%C3%B3n%20de%20Curso`,
  ADMIN_ORGANIZATION: (id) => `${API_URL}/admin/organizations/${id}`,
  ADMIN_ORGANIZATION_SCHEDULE: (id) => `${API_URL}/admin/organizations/${id}/schedule`,
  ADMIN_ORGANIZATION_CALENDAR_INTERVALS: (id) => `${API_URL}/admin/organizations/${id}/calendar-intervals`,
  ADMIN_CALENDAR_EVENT_TYPES: `${API_URL}/admin/calendar-event-types`,
  ADMIN_SECTION_CALENDAR_EVENTS: (id) => `${API_URL}/admin/organizations/${id}/section-calendar-events`,
  ADMIN_SECTION_CURRENT_SEMESTER: (id) => `${API_URL}/admin/organizations/${id}/section-current-semester`,
  ADMIN_ORGANIZATION_CALENDAR_EVENTS: (id) => `${API_URL}/admin/organizations/${id}/calendar-events`,
  ADMIN_CALENDAR_EVENT: (id) => `${API_URL}/admin/calendar-events/${id}`,
  ADMIN_ORGANIZATION_PARENTS: (id) => `${API_URL}/admin/organizations/${id}/parents`,
  ADMIN_ORGANIZATIONS_SEARCH: `${API_URL}/admin/organizations/search`,

  // ── Admin – Personas ──────────────────────────────────────────────────
  ADMIN_PERSONS: `${API_URL}/admin/persons`,
  ADMIN_PERSONS_FILTER: `${API_URL}/admin/persons/filter`,
  ADMIN_PERSON: (id) => `${API_URL}/admin/persons/${id}`,
  ADMIN_PERSON_ORGANIZATIONS: (id) => `${API_URL}/admin/persons/${id}/organizations`,

  // ── Admin – Roles ─────────────────────────────────────────────────────
  ADMIN_ROLES: `${API_URL}/admin/roles`,
  ADMIN_ROLE: (id) => `${API_URL}/admin/roles/${id}`,

  // ── Admin – Usuarios ──────────────────────────────────────────────────
  ADMIN_USERS: `${API_URL}/admin/users`,
  ADMIN_USER: (id) => `${API_URL}/admin/users/${id}`,
  ADMIN_USER_RESET_PASSWORD: (id) => `${API_URL}/admin/users/${id}/reset-password`,

  // ── IA ────────────────────────────────────────────────────────────────
  AI_GENERATE_PLANNING: `${API_URL}/ai/generate-planning`,
  AI_ACTIVE_PLANNING_TEMPLATE: `${API_URL}/ai/active-planning-template`,
  AI_BULK_SESSION: `${API_URL}/ai/bulk-session`,
  AI_BULK_SESSION_UPDATE: (id) => `${API_URL}/ai/bulk-session/${id}`,
  AI_LINK_PLANNED_CLASS: `${API_URL}/ai/link-planned-class`,

  // ── Admin – Definiciones de competencia ───────────────────────────────
  ADMIN_COMPETENCY_DEFINITIONS: `${API_URL}/admin/competency-definitions`,
  ADMIN_COMPETENCY_DEFINITIONS_OPERATIONS: `${API_URL}/admin/competency-definitions/operations`,
  ADMIN_COMPETENCY_DEFINITION: (id) => `${API_URL}/admin/competency-definitions/${id}`,
  ADMIN_COMPETENCY_DEFINITION_DEPENDENCIES: (id) =>
    `${API_URL}/admin/competency-definitions/${id}/dependencies`,

  // ── Master – Dashboard Clases ─────────────────────────────────────────
  MASTER_ORGANIZATIONS: `${API_URL}/master/organizations`,
  MASTER_ESTABLISHMENT_COSTS: `${API_URL}/master/dashboard/establishments`,

  // ── Master – Dashboard IA ─────────────────────────────────────────────
  MASTER_AI_SUMMARY: `${API_URL}/master/dashboard/ai/summary`,
  MASTER_AI_TOKENS_BY_DAY: `${API_URL}/master/dashboard/ai/tokens-by-day`,
  MASTER_AI_TOP_TENANTS: `${API_URL}/master/dashboard/ai/top-tenants`,
  MASTER_AI_TEMPORAL: `${API_URL}/master/dashboard/ai/temporal`,

  // ── Master – Usuarios ─────────────────────────────────────────────────
  MASTER_USERS: `${API_URL}/master/users`,
  MASTER_USERS_ALL: `${API_URL}/master/users/all`,
  MASTER_USER_RESET_PASSWORD: (orgId, credId) =>
    `${API_URL}/master/users/${orgId}/${credId}/reset-password`,
  MASTER_USER_STATUS: (orgId, credId) =>
    `${API_URL}/master/users/${orgId}/${credId}/status`,

  // ── Master – Gestión de Tenants ───────────────────────────────────────
  MASTER_TENANTS: `${API_URL}/master/tenants`,
  MASTER_TENANT: (orgId) => `${API_URL}/master/tenants/${orgId}`,
  MASTER_TENANT_PLAN: (orgId) => `${API_URL}/master/tenants/${orgId}/plan`,
  MASTER_TENANT_SUSPEND: (orgId) => `${API_URL}/master/tenants/${orgId}/suspend`,
  MASTER_TENANT_REACTIVATE: (orgId) => `${API_URL}/master/tenants/${orgId}/reactivate`,
  MASTER_TENANT_USAGE: (orgId) => `${API_URL}/master/tenants/${orgId}/usage`,
  MASTER_TENANT_FEATURES: (orgId) => `${API_URL}/master/features/${orgId}`,

  // ── Feature Flags ─────────────────────────────────────────────────────
  FEATURES_ENABLED: `${API_URL}/features/enabled`,

  // ── Tickets ───────────────────────────────────────────────────────────
  TICKETS: `${API_URL}/tickets`,
  TICKETS_MINE: `${API_URL}/tickets/mine`,
  TICKET_STATUS: (id) => `${API_URL}/tickets/${id}/status`,
  TICKET_ASSIGN: (id) => `${API_URL}/tickets/${id}/assign`,
  TICKET_RESOLVE: (id) => `${API_URL}/tickets/${id}/resolve`,
  TICKET_COMMENTS: (id) => `${API_URL}/tickets/${id}/comments`,
};
